import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api/client';
import { useT } from '../../i18n';

// All series, newest first. A series is created FROM a base story (the button
// on the story editor), so there's no "new series" action here — this is the
// index to jump back into an existing one.
export default function SeriesList() {
  const t = useT();
  const [series, setSeries] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/api/admin/series')
      .then((d) => setSeries(d.series))
      .catch((e) => setError(e.message || t.adminSeriesLoadFailed));
  }, []);

  if (error) return <div className="admin-page" dir="rtl"><h2>{error}</h2></div>;
  if (!series) return <div className="admin-page" dir="rtl"><p>{t.adminSeriesLoading}</p></div>;

  return (
    <div className="admin-page" dir="rtl">
      <h1 className="page-title">{t.adminSeriesListTitle}</h1>
      {!series.length && (
        <p className="admin-scene-subtitle">
          {t.adminSeriesEmptyHelp}
        </p>
      )}
      {!!series.length && (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr><th>{t.adminSeriesColTitle}</th><th>{t.adminSeriesColChildren}</th><th>{t.adminSeriesColApproved}</th><th>{t.adminSeriesColType}</th><th>{t.adminSeriesColDate}</th></tr>
            </thead>
            <tbody>
              {series.map((s) => (
                <tr key={s._id}>
                  <td><Link to={`/admin/series/${s._id}`} className="admin-link" style={{ color: '#6366f1' }}>{s.title || '—'}</Link></td>
                  <td>{s.memberCount}</td>
                  <td>{s.approvedCount}</td>
                  <td>{s.sameStoryline ? t.adminSeriesSameStory : t.adminSeriesNewStory} · {s.sameGraphics ? t.adminSeriesSameGraphics : t.adminSeriesNewGraphics}</td>
                  <td>{new Date(s.createdAt).toLocaleDateString('ar')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
